import { skyBreakPoints } from './constants'
import { getVerticalScrollbarWidthIfVisible } from '@/utils/breakpoints/MediaQuery/utils'
import useMediaQuery from '@/hooks/useMediaQuery'

const useSkyAdSize = (isLeftSky: boolean = false) => {
    const scrollWidth = getVerticalScrollbarWidthIfVisible()
    const { limitedSky, fullSky } = isLeftSky ? skyBreakPoints.leftSky : skyBreakPoints.rightSky
    const showSkyAd = useMediaQuery(`only screen and (min-width: ${limitedSky + scrollWidth}px)`)
    const isFullSkyAd = useMediaQuery(`only screen and (min-width: ${fullSky + scrollWidth}px)`)

    return {
        showSkyAd,
        isFullSkyAd,
    }
}

export default useSkyAdSize
